import React, { FC } from 'react';
import { FeedbackResponse } from 'api/feedback';
import { Column, Row } from 'atoms/Layout';
import { Body } from 'atoms/Typography';
import SentimentGauge from 'atoms/SentimentGauge';
import { Sentiment } from 'model/feedback';
import InformationTooltip from '../molecules/InformationTooltip';

interface Props {
    feedback: FeedbackResponse[];
    title: string;
    description?: string | React.ReactNode;
    tagline?: (sentiment: Sentiment) => string;
}

const InsightScore: FC<Props> = ({ feedback, title, description, tagline }) => {
    const averageSentiment = feedback.length ? feedback.reduce((acc, f) => acc + f.analysis.sentimentScore, 0) / feedback.length : 0;

    return <Column>
        <div style={{ minWidth: 260}} />
        <Row size="full" nowrap gap="medium">
            <Column size="full">
                <Row vcenter gap="small">
                    <Body>{title}</Body>
                    { description && <InformationTooltip>{ description }</InformationTooltip> }
                </Row>
            </Column>
            <Column>
                <SentimentGauge sentimentScore={averageSentiment} />
            </Column>
        </Row>
    </Column>

}

export default InsightScore;
